export const TRIES_BEFORE_TIMEOUT = 3;